import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import request from "../util/request";
import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_VERIFY_OTP,
  RESET_PASSWORD,
} from "constants/ActionTypes";

import {
  forgot_password_success,
  forgot_password_failed,
  forgot_password_verify_otp_success,
  forgot_password_verify_otp_failed,
  reset_password_success,
  reset_password_failed,
} from "actions/forgotPassword";

const forgot_password_request = async (payload) =>
  await request({
    path: "/forgot-password",
    method: "POST",
    body: JSON.stringify(payload),
  });
const forgot_password_verify_otp_request = async (payload) =>
  await request({
    path: "/forgot-password-verify-otp",
    method: "POST",
    body: JSON.stringify(payload),
  });
const reset_password_request = async (payload) =>
  await request({
    path: "/reset-password",
    method: "PATCH",
    body: JSON.stringify(payload),
  });

function* forgot_password_saga({ payload }) {
  try {
    const response = yield call(forgot_password_request, payload);
    const { data = {} } = response;

    if (
      response.status === 200 &&
      response.code === "user_reset_password_token_sent"
    ) {
    //   yield put(forgot_password_verify_otp_success(data));
      yield put(forgot_password_success(data));
    } else {
      yield put(
        forgot_password_failed({
          message: response.message,
          code: response.code,
        })
      );
    }
  } catch (error) {
    console.error(error);
  }
}
function* forgot_password_verify_otp_saga({ payload }) {
  try {
    const response = yield call(forgot_password_verify_otp_request, payload);
    const { data = {} } = response;

    if (response.status === 200 && response.code === "otp_matched") {
      yield put(forgot_password_verify_otp_success(data));
    } else {
      yield put(
        forgot_password_verify_otp_failed({
          message: response.message,
          code: response.code,
        })
      );
    }
  } catch (error) {
    console.error(error);
  }
}
function* reset_password_saga({ payload }) {
  try {
    const response = yield call(reset_password_request, payload);
    const { data = {} } = response;

    if (response.status === 200 && response.code === "password_reset_success") {
      yield put(reset_password_success(data));
    } else {
      yield put(
        reset_password_failed({
          message: response.message,
          code: response.code,
        })
      );
    }
  } catch (error) {
    console.error(error);
  }
}

function* forgot_password() {
  yield takeLatest(FORGOT_PASSWORD, forgot_password_saga);
}
function* forgot_password_verify_otp() {
  yield takeLatest(FORGOT_PASSWORD_VERIFY_OTP, forgot_password_verify_otp_saga);
}
function* reset_password() {
  yield takeLatest(RESET_PASSWORD, reset_password_saga);
}

export default function* rootSaga() {
  yield all([
    fork(forgot_password),
    fork(forgot_password_verify_otp),
    fork(reset_password),
  ]);
}
